<template>
  <div class="column content-box">
    <div
      class="cardHeader"
    >
      <h5>{{ $t('FLOW.LLM_EDIT_CARD.HEAD') }}</h5>
    </div>
    <form class="row" @submit.prevent>
      <div class="medium-12 columns">

         <MultiselectDropdown
          :label="$t('FLOW.LLM_EDIT_CARD.ASSISTANT.LABEL')"
          :infoList="[]"
          :error="$v.content.assistant_id.$error ? 'Please select an assistant' : ''"
        >
          <multiselect
            class="column small-12"
            v-model="selected_assistant"
            :options="LLMAssistants"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('FLOW.LLM_EDIT_CARD.ASSISTANT.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @select="onItemSelect"
          />
        </MultiselectDropdown>


         <!-- <MultiselectDropdown
        :label="$t('FLOW.PROMPT.FORM.OUTPUT_TYPE.LABEL')"
        >
             <multiselect
              class="column small-12"
              v-model="selected_format_type"
              :options="resFormats"
              track-by="id"
              label="name"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :disabled="false"
              :placeholder="$t('FLOW.PROMPT.FORM.OUTPUT_TYPE.PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            />
        </MultiselectDropdown> -->

      </div>


      <div class="modal-footer">
        <woot-button @click.prevent="allDone">
          {{ $t('FLOW.DONE') }}
        </woot-button>
        <woot-button variant="clear" @click.prevent="onClose">
          {{ $t('FLOW.CANCEL') }}
        </woot-button>
      </div>

    </form>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import FluentIcon from '../../../../../../../shared/components/FluentIcon/Index.vue';
import DashboardIcon from '../../../../../../../shared/components/FluentIcon/DashboardIcon.vue';
import FlowApi from '../../FlowApi';
import { required, minValue, maxValue,  minLength, maxLength, sameAs } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import MultiselectDropdown from "components/ui/inputs/MultiselectDropdown.vue"
import {LLM_RESPONSE_FORMAT} from "dashboard/routes/dashboard/settings/campaigns/llm_chatbot/llm.constant.js";


export default {
  components: {
    FluentIcon,
    DashboardIcon,
    MultiselectDropdown,
  },

  mixins: [alertMixin],
  props: {
    dref: {
      required: true,
    },
    botid: {
      required: true,
    },
    content: {
      required: true,
    }
  },
  data() {
    return {
        selected_assistant: null,
        selected_format_type: LLM_RESPONSE_FORMAT[0],
        resFormats: LLM_RESPONSE_FORMAT,
        // assistants: [{id:1,title:'Assistant 1'},{id:'asst_wfUu1vIFo2N9PydbMN3OQFvF',title:'Assistant 2'},]
    };
  },
  computed:{
    ...mapGetters({
      currentUser: 'getCurrentUser',
      LLMAssistants: 'llmbots/getLLMAssistants'
    }),

  },
  mounted(){
    this.prePopulateFields();
  },
  watch: {

  },

  validations: {
    botid: {
      required,
    },
    content: {
        assistant_id:{
            required: true,
            minLength: minLength(1),
        }
    },
  },
  methods: {
    async allDone() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showAlert("Please fill in all required fields correctly.");
        return;
      }
      this.content.format_type = this.selected_format_type?.id || 'text';
      this.$emit('content-edit-done', this.content);
    },

    onClose() {
      this.$emit('on-close');
    },
    prePopulateFields(){
        if (this.content.assistant_id) {
            // find from the list
            this.selected_assistant = this.LLMAssistants.find(el=>el.id===this.content.assistant_id);
        }
        if (this.content.format_type) {
            // find from the list
            this.selected_format_type = this.resFormats.find(el=>el.id===this.content.format_type);
        }
    },
    onItemSelect(item){
      this.content.assistant_id = item.id;
      console.log(item,this.content);
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .ProseMirror-woot-style {
  height: 8rem;
}

.bottom-margin {
  margin-bottom: var(--space-small) !important;
}

.field_item {
  display: flex;
  align-items: center;
  margin-bottom: 1.6em;
}



.cardHeader {
  display: flex;
  padding: 8px;
  padding-left: 24px;
  padding-right: 24px;
  color: grey;
  align-items: center;
}


.action_btn {
  position: absolute;
  top: 4px;
  right: 4px;
}

</style>
